import { Truck, Check, X } from "lucide-react";
import { StatusBadge } from "./StatusBadge";

export const TransportersTab = ({ transporters, transporterFilter, setTransporterFilter, onVerify }) => (
  <div>
    <div className="flex items-center gap-2 mb-4">
      <select
        value={transporterFilter}
        onChange={(e) => setTransporterFilter(e.target.value)}
        className="input-minimal w-auto"
        data-testid="transporter-filter"
      >
        <option value="pending">Pending</option>
        <option value="approved">Verified</option>
        <option value="rejected">Rejected</option>
        <option value="all">All</option>
      </select>
    </div>

    <div className="space-y-3">
      {transporters.length === 0 ? (
        <div className="glass-card p-8 text-center">
          <Truck className="w-12 h-12 text-[#3F3F46] mx-auto mb-3" />
          <p className="text-[#A1A1AA]">No transporters found</p>
        </div>
      ) : (
        transporters.map((transporter) => (
          <div key={transporter.transporter_id} className="glass-card p-4">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h4 className="text-[#EDEDED] font-medium">{transporter.business_name}</h4>
                  <StatusBadge status={transporter.verification_status} />
                </div>
                <p className="text-sm text-[#71717A]">
                  {transporter.location_city}, {transporter.location_state}
                </p>
                <div className="flex flex-wrap gap-4 mt-2 text-sm text-[#A1A1AA]">
                  <span>{transporter.owner_email}</span>
                  {transporter.license_number && (
                    <span>
                      License: {transporter.license_number} ({transporter.license_state})
                    </span>
                  )}
                </div>
                <div className="flex flex-wrap gap-1 mt-2">
                  {transporter.species_served?.slice(0, 4).map((species) => (
                    <span
                      key={species}
                      className="px-2 py-0.5 bg-[#3B82F6]/10 text-[#3B82F6] rounded text-xs capitalize"
                    >
                      {species}
                    </span>
                  ))}
                </div>
                <p className="text-xs text-[#52525B] mt-2">
                  Serves {transporter.regions_served?.length || 0} states •
                  {transporter.base_rate_per_mile
                    ? ` $${transporter.base_rate_per_mile}/mi`
                    : " Quote on request"}
                </p>
              </div>
              {transporter.verification_status === "pending" && (
                <div className="flex gap-2 ml-4">
                  <button
                    onClick={() => onVerify(transporter.transporter_id, "approve")}
                    className="p-2 rounded-lg bg-[#22C55E]/10 text-[#22C55E] hover:bg-[#22C55E]/20 transition-colors"
                    title="Approve"
                    data-testid={`approve-transporter-${transporter.transporter_id}`}
                  >
                    <Check className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => onVerify(transporter.transporter_id, "reject")}
                    className="p-2 rounded-lg bg-[#EF4444]/10 text-[#EF4444] hover:bg-[#EF4444]/20 transition-colors"
                    title="Reject"
                    data-testid={`reject-transporter-${transporter.transporter_id}`}
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  </div>
);
